export { default } from "./SkeletonPlayerView";
